import {
  AfterViewInit,
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  HostBinding,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '.nav-item:not(.more-dropdown)',
})
export class NavItemElement implements AfterViewInit {
  rightPos: number = 0;

  constructor(public elementRef: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.rightPos =
      this.elementRef.nativeElement.getBoundingClientRect().left + this.elementRef.nativeElement.getBoundingClientRect().width;
  }
}

@Directive({
  selector: '.nav-item.more-dropdown',
})
export class MoreDropdownElement {
  constructor(public elementRef: ElementRef<HTMLElement>) {}
}

@Directive({
  selector: '.navbar-nav',
})
export class NavBarElement implements AfterViewInit, OnDestroy {
  @ContentChild(MoreDropdownElement, { static: false }) moreBtn: MoreDropdownElement;
  @ContentChildren(NavItemElement, { read: NavItemElement }) navItems: NavItemElement[];
  @HostBinding('style.word-break') wordBreak: string = 'break-word';
  @ContentChild('greedyDropdown', { static: true }) moreDropdown: ElementRef<HTMLElement>;
  navRightPos: number = 0;
  private _destroyed$ = new Subject<void>();

  constructor(private elementRef: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  ngAfterViewInit(): void {
    this._updateNavigationMenu();

    fromEvent(window, 'resize')
      .pipe(takeUntil(this._destroyed$))
      .subscribe(() => {
        this._updateNavigationMenu();
      });
  }

  private _updateNavigationMenu(): void {
    if (!this.moreDropdown) {
      return;
    }

    this.navRightPos =
      this.elementRef.nativeElement.getBoundingClientRect().left +
      (this.elementRef.nativeElement.getBoundingClientRect().width -
        this.moreBtn.elementRef.nativeElement.getBoundingClientRect().width);

    this.navItems.forEach((item) => {
      // If nav item right position is greater than navbar right position, append the item to the more dropdown menu, else append it to the navbar
      if (item.rightPos > this.navRightPos) {
        if( !item.elementRef.nativeElement.classList.contains('static-nav-item') ){
          this.renderer.appendChild(this.moreDropdown.nativeElement, item.elementRef.nativeElement);
        }
      } else {
        if( !item.elementRef.nativeElement.classList.contains('static-nav-item') ){
          this.renderer.appendChild(this.elementRef.nativeElement, item.elementRef.nativeElement);
        }
      }

      // if item contains static-nav-item class it will be appended just before the more button dropdown
      if( item.elementRef.nativeElement.classList.contains('static-nav-item')){
        this.renderer.appendChild(this.elementRef.nativeElement, item.elementRef.nativeElement);
      }
    });

    // If more dropdown has items, append the more button to the navbar
    if (this.moreDropdown.nativeElement.children.length > 0) {
      this.renderer.appendChild(this.elementRef.nativeElement, this.moreBtn.elementRef.nativeElement);
    }
  }
}
